<template>
  <BaseModal
    @close="close"
    class="modal-signin"
  >
    <div class="modal-container">
      <Close class="modal-container-close" @click="close"></Close>
      <div class="modal-corner" @click="corner"></div>
      <div class="modal-corner-label" @click="corner">
        <div class="modal-corner-label-text">帐号登录</div>
      </div>
      <div class="modal-title">微信扫码</div>
      <div class="qrcode-header">
        <div class="qrcode-header-line"></div>
        <span class="qrcode-header-text">登录·注册</span>
        <div class="qrcode-header-line"></div>
      </div>
      <div class="modal-body">
        <div class="form-qrcode" id="login-qrcode-container">
          <div class="weui-loading" style="margin: auto;display: flex;"></div>
        </div>
        <div class="form-qrcode-tip">
          <div>老用户可以点击右上角的账号登录</div>
          <div>使用手机号和密码登录</div>
        </div>
        <!-- <SigninForm
          :error="error"
          :isShowSignup="false"
          @commit="commit"
          @reset="reset"
          @signup="signup"
          @update:error="e => $emit('update:error', e)"
        ></SigninForm> -->
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import { SigninForm } from '../form'
import Close from '../Close.vue'
export default {
  components: {
    BaseModal,
    SigninForm,
    Close
  },
  props: {
    error: {
      default: null
    }
  },
  data () {
    return {
      qrcodeGenerated: false
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit (input) { this.$emit('commit', input) },
    reset () { this.$emit('reset') },
    signup () { this.$emit('signup') },
    corner () { this.$emit('corner') },
    /* eslint-disable */
    /**
     * 這從 <script src="//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"> 來的
     * 因為要客製化大小，所以要指定 width, height
     */
    _generateQrcode (options) {
      let a = window
      let b = document
      let customQrcodeWidth = `${230 + 1 * 2}px`
      function d(a) {
          var c = "default";
          a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false");
          var d = b.createElement("iframe")
            , e = "https://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&redirect_uri=" + a.redirect_uri + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c;
          e += a.style ? "&style=" + a.style : "",
          e += a.href ? "&href=" + a.href : "",
          d.src = e,
          d.frameBorder = "0",
          d.allowTransparency = "true",
          d.scrolling = "no",
          d.width = customQrcodeWidth,
          d.height = customQrcodeWidth;
          var f = b.getElementById(a.id);
          f.innerHTML = "",
          f.appendChild(d)
      }
      return d(options)
    }, /* eslint-enable */
    generateQrcode () {
      console.log('generateQrcode', this.qrcodeGenerated)
      if (this.qrcodeGenerated) {
        return
      }
      let href = `${window.location.origin}/static/weixin-qrcode.css`
      let key = 'dartcome.pr'
      switch (window.location.hostname) {
        case 'localhost':
        case '127.0.0.1':
          key += '-local'
          break
        case 'dartcome.nutsb.com':
          key += '-dev'
          break
      }
      this._generateQrcode({
        id: 'login-qrcode-container',
        appid: 'wx0ec3eed018b017ed',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(`https://api.ranch.nutsbp.com/redirect?key=${key}`),
        state: '',
        // style: '',
        href,
        self_redirect: true // 因為要先等 code 換 token 寫入，所以我們自己 redirect
      })
    }
  },
  mounted () {
    this.generateQrcode()
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.qrcode-header {
  color: RGBA(65, 106, 240, 1);
  font-size: 14px;
  padding: 10px;
  text-align: center;
  & .qrcode-header-text {
    vertical-align: middle;
    margin: 0 10px;
  }
  & .qrcode-header-line {
    width:20px;
    height:2px;
    background:rgba(65,106,240,1);
    display: inline-block;
    vertical-align: middle;
  }
}
.form-qrcode {
  margin: auto;
  width: 230px;
}
.form-qrcode-tip {
  font-size: 16px;
  text-align: center;
  color: RGBA(153, 153, 153, 1);
  padding-top: 20px;
}
.modal-signin {
  & .modal-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);

    @media (--mediaPc) {
      height: 464px;
      width: 400px;
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      height: 100%;
      width: 100%;
    }

    & .modal-container-close {
      position: absolute;
      right: -35px;
      top: -25px;
    }

    & .modal-corner {
      position: absolute;
      height: 52px;
      width: 51px;
      right: 15px;
      top: 15px;
      background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/inbox/cut_page/dc_sign_computer.png');
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;
    }

    & .modal-corner-label {
      position: absolute;
      width: 91px;
      height: 28px;

      right: 63px;
      top: 31px;
      cursor: pointer;
      background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/inbox/cut_page/dc_sign_text_frame.png');
      & .modal-corner-label-text {
        text-align: center;
        padding: calc(calc(28px - 13px) / 2) 0;
        color: RGBA(65, 106, 240, 1);
        font-size: 13px;
      }
    }

    & .modal-title {
      font-size: 32px;
      text-align: center;
      color: var(--colorMain);
      padding-top: 80px;
    }
    & .modal-body {
      @media (--mediaPc) {
        padding-top: calc(14px - 5px);
      }
      @media (--mediaMobile) {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 55%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/WeixinQrcodeModal.vue